<template>
  <div class="Videos">
    <v-container>
      <v-row class="fill-height pa-0 ma-0" justify="center" align="center">
        <v-col cols="12" lg="12" xl="10" md="10" sm="12">
          <v-row class="pa-0 ma-0 text-center">
            <v-col cols="12">
              <div class="font-weight-bold text-h5">
                STUDENT LIFE
              </div>
              <div class="text-title mb-6 mt-6">
                One of the biggest changes in college is that you have much more freedom
                (for example to set your schedule, choose your major and go to class)
              </div>
            </v-col>
          </v-row>
          <v-row class="pa-0 ma-0">
            <v-col cols="12" lg="4" md="4" xl="4">
              <v-img src="@/assets/students-1.jpg"></v-img>
            </v-col>
            <v-col cols="12" lg="4" md="4" xl="4">
              <v-img src="@/assets/students-2.jpg"></v-img>
            </v-col>
            <v-col cols="12" lg="4" md="4" xl="4">
              <v-img src="@/assets/students-3.jpg"></v-img>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Videos',
};
</script>

<style lang="scss" scoped>

</style>
